module.exports = __webpack_public_path__ + "assets/img/insight1.8a0fb457.jpg";